import { getLanguage } from '@cmsgov/design-system';
import { t } from "../i18n";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
export const PrivacySettingsLink = props => /*#__PURE__*/_jsx("button", {
  className: props.className,
  onClick: () => window.utag?.gdpr?.showConsentPreferences(getLanguage()),
  children: props.children || t('footer.privacySettings')
});
export default PrivacySettingsLink;